export function getLastSymbolFromNumber(i: number | undefined): number {
  if (typeof i !== 'number') {
    return i;
  }

  return +[...i.toString()].pop();
}
